<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<path d="M16 0H9.99997L12.293 2.293L7.29297 7.293L8.70697 8.707L13.707 3.707L16 6V0Z"/>
<path d="M15 16H1C0.448 16 0 15.552 0 15V1C0 0.448 0.448 0 1 0H8V2H2V14H14V8H16V15C16 15.552 15.552 16 15 16Z"/>
</svg>
